import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { toggleNavigationPhotos } from '../../actions/sidebar'
import getPhotos from '../../repositories/getPhotos'
import NavigationItem from './../../components/NavigationItem'

const mapStateToProps = state => ({
  isToggled: dotProp.get(state, `sidebar.photos.isToggled`, false),
})

const mapDispatchToProps = dispatch => ({
  toggle: () => dispatch(toggleNavigationPhotos(getPhotos(window.fetch))),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavigationItem)



// WEBPACK FOOTER //
// ./src/containers/NavigationItem/PhotosItem.js